import { render, staticRenderFns } from "./editGoods.vue?vue&type=template&id=456ea404"
import script from "./editGoods.vue?vue&type=script&lang=js"
export * from "./editGoods.vue?vue&type=script&lang=js"
import style0 from "./editGoods.vue?vue&type=style&index=0&id=456ea404&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports